import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoginPagePage } from 'src/app/login-page/login-page.page';
import { SearchPage } from 'src/app/search/search.page';
import { LoaderService } from 'src/app/services/loader.service';
import {
  AuthenticationStore,
  SearchType,
  SmartSearch,
  UserInfo,
} from 'src/app/stores/authentication.store';
import { CheckoutStore } from 'src/app/stores/checkout.store';
import {
  ProductDetailResponse,
  ProductStore,
} from 'src/app/stores/product.store';
import { imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-navbar-header',
  templateUrl: './navbar-header.component.html',
  styleUrls: ['./navbar-header.component.scss'],
})
export class NavbarHeaderComponent implements OnInit {
  accountPage: any;
  searchResult: string = null;
  products: any;
  imageUrl = imageUrl;
  clickCount: number = 0;
  @Input() productPage;
  @Input() messageScreen: boolean = false;

  @Input() category;
  @Input() productDetails: ProductDetailResponse;
  @Input() productId;
  languageTranslate: string;
  userInfo: UserInfo;
  @ViewChild('popover') popover;
  isPageLoading: boolean = true;
  isOpen = false;
  constructor(
    private route: Router,
    private modalCtrl: ModalController,
    public auth: AuthenticationStore,
    public checkoutStore: CheckoutStore,
    private productStore: ProductStore,
    private elementRef: ElementRef,
    private navController: NavController,
    private loaderService: LoaderService,
    public platform: Platform,
    public translate: TranslateService,
    private authenticationStore: AuthenticationStore,
    private router: Router
  ) {
    this.auth.isLogin.subscribe(async (data) => {
      this.isPageLoading = true;
      if (data) await this.getUserInfo();
    });
    this.auth.isLogout.subscribe(async (data) => {
      this.isPageLoading = true;
      if (data) await this.getUserInfo();
    });
  }

  async getUserInfo() {
    try {
      var resp = await this.auth.tokenVerify();
      this.userInfo = resp.data;
      this.languageTranslate = this.userInfo
        ? this.userInfo.language
        : this.translate.defaultLang;
    } catch (error) {
      this.userInfo = null;
      this.languageTranslate = this.translate.defaultLang;
    } finally {
      this.isPageLoading = false; // Page loading is complete
    }
  }
  async Walletpage() {
    var resp = await this.auth.requiredLogin();
    this.close();
    resp && this.route.navigate(['/account/wallet-page']);
  }
  async Noification() {
    var resp = await this.auth.requiredLogin();
    this.close();
    resp && this.route.navigate(['/notification-page']);
  }

  homePage() {
    this.close();
    this.route.navigate(['/dashboard']);
  }
  Checkoutprocess() {
    this.close();
    this.route.navigate(['/my-product-bag']);
  }

  gotoMessage() {
    this.close();
    this.route.navigate(['/messages/message-screen']);
  }
  async loginPage() {
    this.close();
    if (this.platform.is('mobile')) {
      this.route.navigate(['/login-page']);
    } else {
      // desktop login is a full page (was a modal)
      this.route.navigate(['/login-page'], {
        state: { returnUrl: this.route.url },
      });
    }
  }

  async ngOnInit() {
    this.accountPage = this.platform.is('mobile')
      ? this.route.routerState.snapshot.url == '/account'
      : this.route.routerState.snapshot.url == '/search';
    this.clickCount = 0;
    document.addEventListener('click', this.onClick.bind(this));
    this.userInfo = this.auth.userInfo;
    this.languageTranslate = this.userInfo
      ? this.userInfo.language
      : this.translate.defaultLang;
    await this.getUserInfo();
  }

  onClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const inputElement = this.elementRef.nativeElement.querySelector('input');
    if (inputElement && !inputElement.contains(targetElement)) {
      inputElement.blur();
      this.clickCount++;
      if (this.clickCount === 2) {
        inputElement.focus();
        this.close();
        inputElement.blur();
        this.clickCount = 0;
      }
    }
  }

  async searchProduct(value, type: string) {
    console.log('value', value);
    this.searchResult = type === 'sugestion' ? value : value.target.value;
    await this.productList();
  }

  async enterButton() {
    this.selectSearch(this.searchResult);
  }

  async selectSearch(value) {
    if (this.platform.is('mobile')) {
      const modal = await this.modalCtrl.create({
        component: SearchPage,
        backdropDismiss: true,
        componentProps: {
          value: value,
        },
      });
      if (value) modal.present();
      await modal.onDidDismiss();
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          searchValue: value,
        },
      };
      this.route.navigate(['/search/'], navigationExtras);
    }

    this.close();
  }

  async productList() {
    this.products = null;
    var params = {};
    if (this.searchResult) {
      params = {
        search_text: this.searchResult,
      };
    }
    try {
      this.products = await this.auth.smartSearch(params);
    } catch (error) {
      // suggestions are optional; Enter / the search button still search
      this.products = null;
    }
  }

  redirect(item) {
    this.close();
    // switch (parseInt(item.type)) {
    //   case SearchType.Category:
    //     this.route.navigate(['/category/' + item.id]);
    //     break;
    //   case SearchType.Shop:
    //     this.route.navigate(['/shop/' + item.id]);
    //     break;
    //   case SearchType.Product:
    //     this.route.navigate(['/product/' + item._id]);
    //     break;
    // }
    this.route.navigate(['/product/' + item.slug]);
  }

  close() {
    this.searchResult = null;
  }

  navback() {
    this.route.navigate(['/dashboard']);
  }

  async saveUnsave() {
    if (this.auth.userInfo) {
      this.loaderService.showLoading();
      try {
        await this.productStore.saveUnsaveProduct(this.productId);
        this.productDetails = await this.productStore.getProductDetail(
          this.productId,
          false
        );
        this.loaderService.dismissLoading();
      } catch (error) {
        this.loaderService.dismissLoading();
        this.loaderService.presentToast(
          error.error.data,
          'middle',
          'danger',
          2000
        );
      }
    } else {
      var resp = await this.auth.requiredLogin();
    }
  }

  async selectLanguage(event) {
    if (this.userInfo) {
      this.loaderService.showLoading();
      try {
        var resp: any = await this.auth.changeLanguage({
          language: event.target.value,
        });
        this.languageTranslate = event.target.value;
        this.translate.setDefaultLang(event.target.value);
        this.loaderService.dismissLoading();
        this.loaderService.presentToast(
          this.translate.instant('SELECTED_LAGUAGE.LANGUAGE_CHANGED'),
          'bottom',
          'success'
        );
        this.auth.userInfo = resp.data;
      } catch (error) {
        this.loaderService.dismissLoading();
        this.loaderService.presentToast(
          error.error.data
            ? error.error.data
            : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
          'bottom',
          'danger'
        );
      }
    } else {
      this.translate.setDefaultLang(event.target.value);
    }
  }
  async openPage(link) {
    this.isOpen = false;
    if (link === 'seller') {
      var resp = await this.auth.requiredLogin();
      if (resp) {
        if (this.auth.userInfo && this.auth.userInfo.seller) {
          this.route.navigate(['/seller/my-shop']);
        } else {
          this.route.navigate(['/seller']);
        }
      }
    } else {
      if (link == 'account') {
        this.route.navigate(['/' + link]);
      } else {
        var resp = await this.auth.requiredLogin();
        resp && this.route.navigate(['/' + link]);
      }
    }
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }

  async tablinks(link: string) {
    var resp = await this.auth.requiredLogin();
    resp && this.route.navigate([link]);
  }
}
